import Interaction from "../../../models/interactions/Interaction";
import { IWait } from "../../../models/interactions/Wait";
import NodeNumberField from "../components/NodeNumberField";
import useUpdateSequenceInteraction from "./UpdateSequenceInteraction.hook";

export default function WaitNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const wait = props.interaction as IWait;
  const { updateInteraction } = useUpdateSequenceInteraction();

  return (
    <div className="w-full h-full">
      <NodeNumberField
        label="Seconds"
        onChange={(seconds) =>
          updateInteraction(props.nodeId, {
            ...wait,
            seconds,
          } as IWait)
        }
        value={wait.seconds}
      />
    </div>
  );
}
